<template>
  <div class="navbar navbar-expand-md navbar-dark fixed-top">
    <div class="navbar-brand">
      <router-link to="/" class="d-inline-block">
        <img src="../../assets/light-logo.webp" alt="" />
        <span>Data Tagging Tool</span>
      </router-link>
    </div>

    <div class="d-md-none">
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbar-mobile"
      >
        <i class="icon-tree5"></i>
      </button>
      <button class="navbar-toggler sidebar-mobile-main-toggle" type="button">
        <i class="icon-paragraph-justify3"></i>
      </button>
    </div>

    <div class="collapse navbar-collapse" id="navbar-mobile">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a
            href="#"
            class="navbar-nav-link sidebar-control sidebar-main-toggle d-none d-md-block"
          >
            <i class="icon-paragraph-justify3"></i>
          </a>
        </li>
      </ul>
      <ul class="navbar-nav ml-auto">
        <li class="nav-item dropdown dropdown-user">
          <a
            href="#"
            class="navbar-nav-link d-flex align-items-center dropdown-toggle"
            data-toggle="dropdown"
          >
            <span>{{ username }}</span>
          </a>

          <div class="dropdown-menu dropdown-menu-right">
            <router-link to="/password" class="dropdown-item"
              ><i class="fas fa-key"></i>Change Password</router-link
            >
            <a href="#" class="dropdown-item" @click="logout"
              ><i class="fas fa-sign-out-alt"></i> Logout</a
            >
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      intervalID: null
    }
  },
  computed: {
    ...mapGetters({
      username: 'username'
    })
  },
  methods: {
    ...mapActions({ resetState: 'resetState', isAuth: 'isAuth' }),
    logout () {
      this.resetState()
      setTimeout(() => {
        this.$router.push({ name: 'login' })
      }, 0)
    }
  },
  mounted () {
    window.App.initSidebars()
    if (this.isAuth) {
      this.$socket.emit('init', this.username)
    }

    this.intervalID = setInterval(() => {
      if (!this.$socket.connected) {
        this.$socket.connect()
      }
    }, 1500)
  },
  destroyed () {
    clearInterval(this.intervalID)
  }
}
</script>
